export function formatDecimal(value: number, digits: number): string {
	return value.toFixed(digits).replace(".", ",");
}

export function formatNullableDecimal(
	value: number | null,
	digits: number
): string {
	if (value === null) {
		return "";
	} else {
		return formatDecimal(value, digits);
	}
}

export function formatCurrency(value: number): string {
	return formatDecimal(value, 2);
}

export function formatNullableCurrency(value: number | null): string {
	if (value === null) {
		return "";
	} else {
		return formatCurrency(value);
	}
}

export function formatDecimalWithOptionalDigits(
	value: number,
	digits: number
): string {
	return Number.isInteger(value)
		? value.toFixed()
		: formatDecimal(value, digits);
}
